import { environment } from '../../../environments/environment';
/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * API
 * 
  <img src="https://dev-app.yoursafetycompliance.com/assets/images/branding/YSC-logo.png" alt="Safety Compliance" width="150"/>
  <h3>📌 Welcome to the <strong>Your Safety Compliance API Documentation (Admin Module)</strong> 🚀</h3>
  
 * OpenAPI spec version: 1.0
 */
import {
  HttpClient
} from '@angular/common/http'
import type {
  HttpContext,
  HttpEvent,
  HttpHeaders,
  HttpParams,
  HttpResponse as AngularHttpResponse
} from '@angular/common/http'
import {
  Injectable
} from '@angular/core'
import {
  Observable
} from 'rxjs'
import type {
  ActiveCompanyStatusRequest,
  ActiveCompanyStatusResponse,
  AdminCreateUserRequest,
  AdminCreateUserResponse,
  AdminForgotPasswordRequest,
  AdminForgotPasswordResponse,
  AdminLoginResponse,
  AdminResetPasswordRequest,
  AdminResetPasswordResponse,
  AdminSetupPasswordRequest,
  AdminSetupPasswordResponse,
  AdminUpdateUserRequest,
  AdminUpdateUserResponse,
  BusinessSubTypeListResponse,
  CompleteCompanyApplicationStatusRequest,
  CompleteCompanyApplicationStatusResponse,
  CreateCompanyRequest,
  CreateCompanyResponse,
  DisableAdminUserRequest,
  DisableAdminUserResponse,
  EnableAdminUserRequest,
  EnableAdminUserResponse,
  FileUploadControllerUploadFile201,
  FileUploadControllerUploadFileBody,
  GetAdminUserListParams,
  GetAdminUserListResponse,
  GetBusinessSubTypeListParams,
  GetBusinessTypeListParams,
  GetBusinessTypeListResponse,
  GetCompaniesExcludingTenantParams,
  GetCompaniesExcludingTenantResponse,
  GetCompanyApplicationListParams,
  GetCompanyApplicationListResponse,
  GetCompanyApplicationResponse,
  GetCompanyApplicationStatusListResponse,
  GetCompanyDelegationTokenParams,
  GetCompanyDelegationTokenResponse,
  GetCompanyDetailParams,
  GetCompanyDetailResponse,
  GetCompanyListParams,
  GetCompanyListResponse,
  GetCompanyStatusListResponse,
  GetCompanyTypeListResponse,
  GetContactUs,
  GetContactUsListParams,
  GetContactUsListResponse,
  GetContactUsStatusListResponse,
  GetCountryListParams,
  GetCountryListResponse,
  GetRequestForDemoListParams,
  GetRequestForDemoListResponse,
  GetRequestForDemoResponse,
  GetRequestForDemoStatusListResponse,
  GetRoleListResponse,
  GetStateListParams,
  GetStateListResponse,
  GetTenantListParams,
  GetTenantListResponse,
  GetUploadPreSignedResponse,
  GetUserResponse,
  InactiveCompanyStatusRequest,
  InactiveCompanyStatusResponse,
  LinkCompanyToTenantRequest,
  LinkCompanyToTenantResponse,
  LoginRequest,
  PutPreSignedParams,
  RejectCompanyApplicationStatusRequest,
  RejectCompanyApplicationStatusResponse,
  SignOutRequest,
  SignOutResponse,
  UpdateBusinessAddressRequest,
  UpdateBusinessAddressResponse,
  UpdateBusinessInfoRequest,
  UpdateBusinessInfoResponse,
  UpdateCompanyAddressRequest,
  UpdateCompanyAddressResponse,
  UpdateCompanyBasicRequest,
  UpdateCompanyBasicResponse,
  UpdateCompanyRequest,
  UpdateCompanyResponse,
  UpdateContactUsRequest,
  UpdateContactUsResponse,
  UpdateContactUsStatus,
  UpdateContactUsStatusRequest,
  UpdateGeneralInfoRequest,
  UpdateGeneralInfoResponse,
  UpdateRequestForDemoRequest,
  UpdateRequestForDemoResponse,
  UpdateRequestForDemoStatusRequest,
  UpdateRequestForDemoStatusResponse,
  UploadTempFileRequest,
  UploadTempFileResponse
} from './model'



type HttpClientOptions = {
  headers?: HttpHeaders | {
      [header: string]: string | string[];
  };
  context?: HttpContext;
  observe?: any;
  params?: HttpParams | {
    [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
  };
  reportProgress?: boolean;
  responseType?: any;
  withCredentials?: boolean;
};



@Injectable({ providedIn: 'root' })
export class ApiService {
  constructor(
    private http: HttpClient,
  ) {}/**
 * Operation ID: getUserInfo


 */
 getUserInfo<TData = GetUserResponse>(
     options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    getUserInfo<TData = GetUserResponse>(
     options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    getUserInfo<TData = GetUserResponse>(
     options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;getUserInfo<TData = GetUserResponse>(
     options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.get<TData>(
      `${environment.baseUrl}/admin/users/info`,options
    );
  }

/**
 * Operation ID: getRoleList


 */
 getRoleList<TData = GetRoleListResponse>(
     options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    getRoleList<TData = GetRoleListResponse>(
     options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    getRoleList<TData = GetRoleListResponse>(
     options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;getRoleList<TData = GetRoleListResponse>(
     options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.get<TData>(
      `${environment.baseUrl}/admin/roles`,options
    );
  }

/**
 * Operation ID: getAdminUserList


 */
 getAdminUserList<TData = GetAdminUserListResponse>(
    params?: GetAdminUserListParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    getAdminUserList<TData = GetAdminUserListResponse>(
    params?: GetAdminUserListParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    getAdminUserList<TData = GetAdminUserListResponse>(
    params?: GetAdminUserListParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;getAdminUserList<TData = GetAdminUserListResponse>(
    params?: GetAdminUserListParams, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.get<TData>(
      `${environment.baseUrl}/admin/users`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Operation ID: createAdminUser


 */
 createAdminUser<TData = AdminCreateUserResponse>(
    adminCreateUserRequest: AdminCreateUserRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    createAdminUser<TData = AdminCreateUserResponse>(
    adminCreateUserRequest: AdminCreateUserRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    createAdminUser<TData = AdminCreateUserResponse>(
    adminCreateUserRequest: AdminCreateUserRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;createAdminUser<TData = AdminCreateUserResponse>(
    adminCreateUserRequest: AdminCreateUserRequest, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.post<TData>(
      `${environment.baseUrl}/admin/users`,
      adminCreateUserRequest,options
    );
  }

/**
 * Operation ID: enableAdminUser


 */
 enableAdminUser<TData = EnableAdminUserResponse>(
    enableAdminUserRequest: EnableAdminUserRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    enableAdminUser<TData = EnableAdminUserResponse>(
    enableAdminUserRequest: EnableAdminUserRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    enableAdminUser<TData = EnableAdminUserResponse>(
    enableAdminUserRequest: EnableAdminUserRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;enableAdminUser<TData = EnableAdminUserResponse>(
    enableAdminUserRequest: EnableAdminUserRequest, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.put<TData>(
      `${environment.baseUrl}/admin/users/status/enable`,
      enableAdminUserRequest,options
    );
  }

/**
 * Operation ID: disableAdminUser


 */
 disableAdminUser<TData = DisableAdminUserResponse>(
    disableAdminUserRequest: DisableAdminUserRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    disableAdminUser<TData = DisableAdminUserResponse>(
    disableAdminUserRequest: DisableAdminUserRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    disableAdminUser<TData = DisableAdminUserResponse>(
    disableAdminUserRequest: DisableAdminUserRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;disableAdminUser<TData = DisableAdminUserResponse>(
    disableAdminUserRequest: DisableAdminUserRequest, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.put<TData>(
      `${environment.baseUrl}/admin/users/status/disable`,
      disableAdminUserRequest,options
    );
  }

/**
 * Operation ID: updateAdminUser


 */
 updateAdminUser<TData = AdminUpdateUserResponse>(
    id: string,
    adminUpdateUserRequest: AdminUpdateUserRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    updateAdminUser<TData = AdminUpdateUserResponse>(
    id: string,
    adminUpdateUserRequest: AdminUpdateUserRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    updateAdminUser<TData = AdminUpdateUserResponse>(
    id: string,
    adminUpdateUserRequest: AdminUpdateUserRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;updateAdminUser<TData = AdminUpdateUserResponse>(
    id: string,
    adminUpdateUserRequest: AdminUpdateUserRequest, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.put<TData>(
      `${environment.baseUrl}/admin/users/${id}`,
      adminUpdateUserRequest,options
    );
  }

/**
 * Operation ID: adminCreatePassword


 */
 adminCreatePassword<TData = AdminSetupPasswordResponse>(
    adminSetupPasswordRequest: AdminSetupPasswordRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    adminCreatePassword<TData = AdminSetupPasswordResponse>(
    adminSetupPasswordRequest: AdminSetupPasswordRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    adminCreatePassword<TData = AdminSetupPasswordResponse>(
    adminSetupPasswordRequest: AdminSetupPasswordRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;adminCreatePassword<TData = AdminSetupPasswordResponse>(
    adminSetupPasswordRequest: AdminSetupPasswordRequest, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.put<TData>(
      `${environment.baseUrl}/admin/auth/setup-password`,
      adminSetupPasswordRequest,options
    );
  }

/**
 * Operation ID: getTenantList


 */
 getTenantList<TData = GetTenantListResponse[]>(
    params?: GetTenantListParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    getTenantList<TData = GetTenantListResponse[]>(
    params?: GetTenantListParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    getTenantList<TData = GetTenantListResponse[]>(
    params?: GetTenantListParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;getTenantList<TData = GetTenantListResponse[]>(
    params?: GetTenantListParams, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.get<TData>(
      `${environment.baseUrl}/admin/tenants`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Operation ID: updateRequestForDemoStatus


 */
 updateRequestForDemoStatus<TData = UpdateRequestForDemoStatusResponse>(
    id: string,
    updateRequestForDemoStatusRequest: UpdateRequestForDemoStatusRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    updateRequestForDemoStatus<TData = UpdateRequestForDemoStatusResponse>(
    id: string,
    updateRequestForDemoStatusRequest: UpdateRequestForDemoStatusRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    updateRequestForDemoStatus<TData = UpdateRequestForDemoStatusResponse>(
    id: string,
    updateRequestForDemoStatusRequest: UpdateRequestForDemoStatusRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;updateRequestForDemoStatus<TData = UpdateRequestForDemoStatusResponse>(
    id: string,
    updateRequestForDemoStatusRequest: UpdateRequestForDemoStatusRequest, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.put<TData>(
      `${environment.baseUrl}/admin/request-for-demo/update-status/${id}`,
      updateRequestForDemoStatusRequest,options
    );
  }

/**
 * Operation ID: updateRequestForDemo


 */
 updateRequestForDemo<TData = UpdateRequestForDemoResponse>(
    id: string,
    updateRequestForDemoRequest: UpdateRequestForDemoRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    updateRequestForDemo<TData = UpdateRequestForDemoResponse>(
    id: string,
    updateRequestForDemoRequest: UpdateRequestForDemoRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    updateRequestForDemo<TData = UpdateRequestForDemoResponse>(
    id: string,
    updateRequestForDemoRequest: UpdateRequestForDemoRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;updateRequestForDemo<TData = UpdateRequestForDemoResponse>(
    id: string,
    updateRequestForDemoRequest: UpdateRequestForDemoRequest, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.put<TData>(
      `${environment.baseUrl}/admin/request-for-demo/${id}`,
      updateRequestForDemoRequest,options
    );
  }

/**
 * Operation ID: getRequestForDemo


 */
 getRequestForDemo<TData = GetRequestForDemoResponse>(
    id: string, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    getRequestForDemo<TData = GetRequestForDemoResponse>(
    id: string, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    getRequestForDemo<TData = GetRequestForDemoResponse>(
    id: string, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;getRequestForDemo<TData = GetRequestForDemoResponse>(
    id: string, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.get<TData>(
      `${environment.baseUrl}/admin/request-for-demo/${id}`,options
    );
  }

/**
 * Operation ID: getRequestForDemoStatusList


 */
 getRequestForDemoStatusList<TData = GetRequestForDemoStatusListResponse>(
     options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    getRequestForDemoStatusList<TData = GetRequestForDemoStatusListResponse>(
     options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    getRequestForDemoStatusList<TData = GetRequestForDemoStatusListResponse>(
     options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;getRequestForDemoStatusList<TData = GetRequestForDemoStatusListResponse>(
     options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.get<TData>(
      `${environment.baseUrl}/admin/request-for-demo-status`,options
    );
  }

/**
 * Operation ID: getRequestForDemoList


 */
 getRequestForDemoList<TData = GetRequestForDemoListResponse>(
    params?: GetRequestForDemoListParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    getRequestForDemoList<TData = GetRequestForDemoListResponse>(
    params?: GetRequestForDemoListParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    getRequestForDemoList<TData = GetRequestForDemoListResponse>(
    params?: GetRequestForDemoListParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;getRequestForDemoList<TData = GetRequestForDemoListResponse>(
    params?: GetRequestForDemoListParams, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.get<TData>(
      `${environment.baseUrl}/admin/request-for-demo`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Operation ID: putPreSigned


 */
 putPreSigned<TData = GetUploadPreSignedResponse>(
    params: PutPreSignedParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    putPreSigned<TData = GetUploadPreSignedResponse>(
    params: PutPreSignedParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    putPreSigned<TData = GetUploadPreSignedResponse>(
    params: PutPreSignedParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;putPreSigned<TData = GetUploadPreSignedResponse>(
    params: PutPreSignedParams, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.get<TData>(
      `${environment.baseUrl}/admin/upload/presigned`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Operation ID: GetFileController_uploadFile


 * @summary Get S3 File
 */
 getFileControllerUploadFile<TData = unknown>(
     options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    getFileControllerUploadFile<TData = unknown>(
     options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    getFileControllerUploadFile<TData = unknown>(
     options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;getFileControllerUploadFile<TData = unknown>(
     options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.get<TData>(
      `${environment.baseUrl}/admin/get-file`,options
    );
  }

/**
 * Operation ID: FileUploadController_uploadFile


 * @summary Upload a file with additional data to S3
 */
 fileUploadControllerUploadFile<TData = FileUploadControllerUploadFile201>(
    fileUploadControllerUploadFileBody: FileUploadControllerUploadFileBody, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    fileUploadControllerUploadFile<TData = FileUploadControllerUploadFile201>(
    fileUploadControllerUploadFileBody: FileUploadControllerUploadFileBody, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    fileUploadControllerUploadFile<TData = FileUploadControllerUploadFile201>(
    fileUploadControllerUploadFileBody: FileUploadControllerUploadFileBody, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;fileUploadControllerUploadFile<TData = FileUploadControllerUploadFile201>(
    fileUploadControllerUploadFileBody: FileUploadControllerUploadFileBody, options?: HttpClientOptions
  ): Observable<TData>  {const formData = new FormData();
if(fileUploadControllerUploadFileBody.file !== undefined) {
 formData.append('file', fileUploadControllerUploadFileBody.file)
 }
if(fileUploadControllerUploadFileBody.title !== undefined) {
 formData.append('title', fileUploadControllerUploadFileBody.title)
 }
if(fileUploadControllerUploadFileBody.description !== undefined) {
 formData.append('description', fileUploadControllerUploadFileBody.description)
 }

    return this.http.post<TData>(
      `${environment.baseUrl}/admin/upload`,
      formData,options
    );
  }

/**
 * Operation ID: updateContactUsStatus


 */
 updateContactUsStatus<TData = UpdateContactUsStatus>(
    id: string,
    updateContactUsStatusRequest: UpdateContactUsStatusRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    updateContactUsStatus<TData = UpdateContactUsStatus>(
    id: string,
    updateContactUsStatusRequest: UpdateContactUsStatusRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    updateContactUsStatus<TData = UpdateContactUsStatus>(
    id: string,
    updateContactUsStatusRequest: UpdateContactUsStatusRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;updateContactUsStatus<TData = UpdateContactUsStatus>(
    id: string,
    updateContactUsStatusRequest: UpdateContactUsStatusRequest, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.put<TData>(
      `${environment.baseUrl}/admin/contact-us/update-status/${id}`,
      updateContactUsStatusRequest,options
    );
  }

/**
 * Operation ID: updateContactUs


 */
 updateContactUs<TData = UpdateContactUsResponse>(
    id: string,
    updateContactUsRequest: UpdateContactUsRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    updateContactUs<TData = UpdateContactUsResponse>(
    id: string,
    updateContactUsRequest: UpdateContactUsRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    updateContactUs<TData = UpdateContactUsResponse>(
    id: string,
    updateContactUsRequest: UpdateContactUsRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;updateContactUs<TData = UpdateContactUsResponse>(
    id: string,
    updateContactUsRequest: UpdateContactUsRequest, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.put<TData>(
      `${environment.baseUrl}/admin/contact-us/${id}`,
      updateContactUsRequest,options
    );
  }

/**
 * Operation ID: getContactUs


 */
 getContactUs<TData = GetContactUs>(
    id: string, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    getContactUs<TData = GetContactUs>(
    id: string, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    getContactUs<TData = GetContactUs>(
    id: string, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;getContactUs<TData = GetContactUs>(
    id: string, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.get<TData>(
      `${environment.baseUrl}/admin/contact-us/${id}`,options
    );
  }

/**
 * Operation ID: getContactUsStatusList


 */
 getContactUsStatusList<TData = GetContactUsStatusListResponse>(
     options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    getContactUsStatusList<TData = GetContactUsStatusListResponse>(
     options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    getContactUsStatusList<TData = GetContactUsStatusListResponse>(
     options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;getContactUsStatusList<TData = GetContactUsStatusListResponse>(
     options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.get<TData>(
      `${environment.baseUrl}/admin/contact-us-status`,options
    );
  }

/**
 * Operation ID: getContactUsList


 */
 getContactUsList<TData = GetContactUsListResponse>(
    params?: GetContactUsListParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    getContactUsList<TData = GetContactUsListResponse>(
    params?: GetContactUsListParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    getContactUsList<TData = GetContactUsListResponse>(
    params?: GetContactUsListParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;getContactUsList<TData = GetContactUsListResponse>(
    params?: GetContactUsListParams, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.get<TData>(
      `${environment.baseUrl}/admin/contact-us`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Operation ID: rejectCompanyApplicationStatus


 */
 rejectCompanyApplicationStatus<TData = RejectCompanyApplicationStatusResponse>(
    rejectCompanyApplicationStatusRequest: RejectCompanyApplicationStatusRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    rejectCompanyApplicationStatus<TData = RejectCompanyApplicationStatusResponse>(
    rejectCompanyApplicationStatusRequest: RejectCompanyApplicationStatusRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    rejectCompanyApplicationStatus<TData = RejectCompanyApplicationStatusResponse>(
    rejectCompanyApplicationStatusRequest: RejectCompanyApplicationStatusRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;rejectCompanyApplicationStatus<TData = RejectCompanyApplicationStatusResponse>(
    rejectCompanyApplicationStatusRequest: RejectCompanyApplicationStatusRequest, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.put<TData>(
      `${environment.baseUrl}/admin/company-application-status/reject`,
      rejectCompanyApplicationStatusRequest,options
    );
  }

/**
 * Operation ID: getCompanyApplicationList


 */
 getCompanyApplicationList<TData = GetCompanyApplicationListResponse[]>(
    params?: GetCompanyApplicationListParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    getCompanyApplicationList<TData = GetCompanyApplicationListResponse[]>(
    params?: GetCompanyApplicationListParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    getCompanyApplicationList<TData = GetCompanyApplicationListResponse[]>(
    params?: GetCompanyApplicationListParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;getCompanyApplicationList<TData = GetCompanyApplicationListResponse[]>(
    params?: GetCompanyApplicationListParams, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.get<TData>(
      `${environment.baseUrl}/admin/company-applications`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Operation ID: getCompanyApplication


 */
 getCompanyApplication<TData = GetCompanyApplicationResponse>(
    id: string, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    getCompanyApplication<TData = GetCompanyApplicationResponse>(
    id: string, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    getCompanyApplication<TData = GetCompanyApplicationResponse>(
    id: string, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;getCompanyApplication<TData = GetCompanyApplicationResponse>(
    id: string, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.get<TData>(
      `${environment.baseUrl}/admin/company-applications/${id}`,options
    );
  }

/**
 * Operation ID: DeleteCompanyApplicationController_execute


 */
 deleteCompanyApplicationControllerExecute<TData = void>(
    id: string, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    deleteCompanyApplicationControllerExecute<TData = void>(
    id: string, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    deleteCompanyApplicationControllerExecute<TData = void>(
    id: string, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;deleteCompanyApplicationControllerExecute<TData = void>(
    id: string, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.delete<TData>(
      `${environment.baseUrl}/admin/company-application/${id}`,options
    );
  }

/**
 * Operation ID: completeCompanyApplicationStatus


 */
 completeCompanyApplicationStatus<TData = CompleteCompanyApplicationStatusResponse>(
    completeCompanyApplicationStatusRequest: CompleteCompanyApplicationStatusRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    completeCompanyApplicationStatus<TData = CompleteCompanyApplicationStatusResponse>(
    completeCompanyApplicationStatusRequest: CompleteCompanyApplicationStatusRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    completeCompanyApplicationStatus<TData = CompleteCompanyApplicationStatusResponse>(
    completeCompanyApplicationStatusRequest: CompleteCompanyApplicationStatusRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;completeCompanyApplicationStatus<TData = CompleteCompanyApplicationStatusResponse>(
    completeCompanyApplicationStatusRequest: CompleteCompanyApplicationStatusRequest, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.put<TData>(
      `${environment.baseUrl}/admin/company-application-status/approve`,
      completeCompanyApplicationStatusRequest,options
    );
  }

/**
 * Operation ID: updateGeneralInfo


 */
 updateGeneralInfo<TData = UpdateGeneralInfoResponse>(
    id: string,
    updateGeneralInfoRequest: UpdateGeneralInfoRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    updateGeneralInfo<TData = UpdateGeneralInfoResponse>(
    id: string,
    updateGeneralInfoRequest: UpdateGeneralInfoRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    updateGeneralInfo<TData = UpdateGeneralInfoResponse>(
    id: string,
    updateGeneralInfoRequest: UpdateGeneralInfoRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;updateGeneralInfo<TData = UpdateGeneralInfoResponse>(
    id: string,
    updateGeneralInfoRequest: UpdateGeneralInfoRequest, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.put<TData>(
      `${environment.baseUrl}/admin/companies/${id}/general/info`,
      updateGeneralInfoRequest,options
    );
  }

/**
 * Operation ID: updateCompanyBasic


 */
 updateCompanyBasic<TData = UpdateCompanyBasicResponse>(
    id: string,
    updateCompanyBasicRequest: UpdateCompanyBasicRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    updateCompanyBasic<TData = UpdateCompanyBasicResponse>(
    id: string,
    updateCompanyBasicRequest: UpdateCompanyBasicRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    updateCompanyBasic<TData = UpdateCompanyBasicResponse>(
    id: string,
    updateCompanyBasicRequest: UpdateCompanyBasicRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;updateCompanyBasic<TData = UpdateCompanyBasicResponse>(
    id: string,
    updateCompanyBasicRequest: UpdateCompanyBasicRequest, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.put<TData>(
      `${environment.baseUrl}/admin/companies/${id}/basic`,
      updateCompanyBasicRequest,options
    );
  }

/**
 * Operation ID: updateCompanyAddress


 */
 updateCompanyAddress<TData = UpdateCompanyAddressResponse>(
    id: string,
    updateCompanyAddressRequest: UpdateCompanyAddressRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    updateCompanyAddress<TData = UpdateCompanyAddressResponse>(
    id: string,
    updateCompanyAddressRequest: UpdateCompanyAddressRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    updateCompanyAddress<TData = UpdateCompanyAddressResponse>(
    id: string,
    updateCompanyAddressRequest: UpdateCompanyAddressRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;updateCompanyAddress<TData = UpdateCompanyAddressResponse>(
    id: string,
    updateCompanyAddressRequest: UpdateCompanyAddressRequest, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.put<TData>(
      `${environment.baseUrl}/admin/companies/${id}/address`,
      updateCompanyAddressRequest,options
    );
  }

/**
 * Operation ID: updateCompany


 */
 updateCompany<TData = UpdateCompanyResponse>(
    id: string,
    updateCompanyRequest: UpdateCompanyRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    updateCompany<TData = UpdateCompanyResponse>(
    id: string,
    updateCompanyRequest: UpdateCompanyRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    updateCompany<TData = UpdateCompanyResponse>(
    id: string,
    updateCompanyRequest: UpdateCompanyRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;updateCompany<TData = UpdateCompanyResponse>(
    id: string,
    updateCompanyRequest: UpdateCompanyRequest, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.put<TData>(
      `${environment.baseUrl}/admin/companies/${id}`,
      updateCompanyRequest,options
    );
  }

/**
 * Operation ID: updateBusinessInfo


 */
 updateBusinessInfo<TData = UpdateBusinessInfoResponse>(
    id: string,
    updateBusinessInfoRequest: UpdateBusinessInfoRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    updateBusinessInfo<TData = UpdateBusinessInfoResponse>(
    id: string,
    updateBusinessInfoRequest: UpdateBusinessInfoRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    updateBusinessInfo<TData = UpdateBusinessInfoResponse>(
    id: string,
    updateBusinessInfoRequest: UpdateBusinessInfoRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;updateBusinessInfo<TData = UpdateBusinessInfoResponse>(
    id: string,
    updateBusinessInfoRequest: UpdateBusinessInfoRequest, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.put<TData>(
      `${environment.baseUrl}/admin/companies/${id}/business/info`,
      updateBusinessInfoRequest,options
    );
  }

/**
 * Operation ID: updateBusinessAddress


 */
 updateBusinessAddress<TData = UpdateBusinessAddressResponse>(
    id: string,
    updateBusinessAddressRequest: UpdateBusinessAddressRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    updateBusinessAddress<TData = UpdateBusinessAddressResponse>(
    id: string,
    updateBusinessAddressRequest: UpdateBusinessAddressRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    updateBusinessAddress<TData = UpdateBusinessAddressResponse>(
    id: string,
    updateBusinessAddressRequest: UpdateBusinessAddressRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;updateBusinessAddress<TData = UpdateBusinessAddressResponse>(
    id: string,
    updateBusinessAddressRequest: UpdateBusinessAddressRequest, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.put<TData>(
      `${environment.baseUrl}/admin/companies/${id}/business/address`,
      updateBusinessAddressRequest,options
    );
  }

/**
 * Operation ID: linkCompanyToTenant


 */
 linkCompanyToTenant<TData = LinkCompanyToTenantResponse>(
    linkCompanyToTenantRequest: LinkCompanyToTenantRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    linkCompanyToTenant<TData = LinkCompanyToTenantResponse>(
    linkCompanyToTenantRequest: LinkCompanyToTenantRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    linkCompanyToTenant<TData = LinkCompanyToTenantResponse>(
    linkCompanyToTenantRequest: LinkCompanyToTenantRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;linkCompanyToTenant<TData = LinkCompanyToTenantResponse>(
    linkCompanyToTenantRequest: LinkCompanyToTenantRequest, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.post<TData>(
      `${environment.baseUrl}/admin/companies/link-company-to-tenant`,
      linkCompanyToTenantRequest,options
    );
  }

/**
 * Operation ID: inActiveCompanyStatus


 */
 inActiveCompanyStatus<TData = InactiveCompanyStatusResponse>(
    inactiveCompanyStatusRequest: InactiveCompanyStatusRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    inActiveCompanyStatus<TData = InactiveCompanyStatusResponse>(
    inactiveCompanyStatusRequest: InactiveCompanyStatusRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    inActiveCompanyStatus<TData = InactiveCompanyStatusResponse>(
    inactiveCompanyStatusRequest: InactiveCompanyStatusRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;inActiveCompanyStatus<TData = InactiveCompanyStatusResponse>(
    inactiveCompanyStatusRequest: InactiveCompanyStatusRequest, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.put<TData>(
      `${environment.baseUrl}/admin/company/status/in-active`,
      inactiveCompanyStatusRequest,options
    );
  }

/**
 * Operation ID: getCompanyList


 */
 getCompanyList<TData = GetCompanyListResponse[]>(
    params?: GetCompanyListParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    getCompanyList<TData = GetCompanyListResponse[]>(
    params?: GetCompanyListParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    getCompanyList<TData = GetCompanyListResponse[]>(
    params?: GetCompanyListParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;getCompanyList<TData = GetCompanyListResponse[]>(
    params?: GetCompanyListParams, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.get<TData>(
      `${environment.baseUrl}/admin/companies`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Operation ID: createCompany


 */
 createCompany<TData = CreateCompanyResponse>(
    createCompanyRequest: CreateCompanyRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    createCompany<TData = CreateCompanyResponse>(
    createCompanyRequest: CreateCompanyRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    createCompany<TData = CreateCompanyResponse>(
    createCompanyRequest: CreateCompanyRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;createCompany<TData = CreateCompanyResponse>(
    createCompanyRequest: CreateCompanyRequest, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.post<TData>(
      `${environment.baseUrl}/admin/companies`,
      createCompanyRequest,options
    );
  }

/**
 * Operation ID: getCompanyDetail


 */
 getCompanyDetail<TData = GetCompanyDetailResponse>(
    params: GetCompanyDetailParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    getCompanyDetail<TData = GetCompanyDetailResponse>(
    params: GetCompanyDetailParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    getCompanyDetail<TData = GetCompanyDetailResponse>(
    params: GetCompanyDetailParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;getCompanyDetail<TData = GetCompanyDetailResponse>(
    params: GetCompanyDetailParams, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.get<TData>(
      `${environment.baseUrl}/admin/companies/detail`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Operation ID: getCompanyDelegationToken


 */
 getCompanyDelegationToken<TData = GetCompanyDelegationTokenResponse>(
    params: GetCompanyDelegationTokenParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    getCompanyDelegationToken<TData = GetCompanyDelegationTokenResponse>(
    params: GetCompanyDelegationTokenParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    getCompanyDelegationToken<TData = GetCompanyDelegationTokenResponse>(
    params: GetCompanyDelegationTokenParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;getCompanyDelegationToken<TData = GetCompanyDelegationTokenResponse>(
    params: GetCompanyDelegationTokenParams, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.get<TData>(
      `${environment.baseUrl}/admin/company/access/delegation/token`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Operation ID: getCompaniesExcludingTenant


 */
 getCompaniesExcludingTenant<TData = GetCompaniesExcludingTenantResponse[]>(
    params: GetCompaniesExcludingTenantParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    getCompaniesExcludingTenant<TData = GetCompaniesExcludingTenantResponse[]>(
    params: GetCompaniesExcludingTenantParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    getCompaniesExcludingTenant<TData = GetCompaniesExcludingTenantResponse[]>(
    params: GetCompaniesExcludingTenantParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;getCompaniesExcludingTenant<TData = GetCompaniesExcludingTenantResponse[]>(
    params: GetCompaniesExcludingTenantParams, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.get<TData>(
      `${environment.baseUrl}/admin/companies/excluding-tenant`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Operation ID: activeCompanyStatus


 */
 activeCompanyStatus<TData = ActiveCompanyStatusResponse>(
    activeCompanyStatusRequest: ActiveCompanyStatusRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    activeCompanyStatus<TData = ActiveCompanyStatusResponse>(
    activeCompanyStatusRequest: ActiveCompanyStatusRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    activeCompanyStatus<TData = ActiveCompanyStatusResponse>(
    activeCompanyStatusRequest: ActiveCompanyStatusRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;activeCompanyStatus<TData = ActiveCompanyStatusResponse>(
    activeCompanyStatusRequest: ActiveCompanyStatusRequest, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.put<TData>(
      `${environment.baseUrl}/admin/company/status/active`,
      activeCompanyStatusRequest,options
    );
  }

/**
 * Operation ID: signOut


 */
 signOut<TData = SignOutResponse>(
    signOutRequest: SignOutRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    signOut<TData = SignOutResponse>(
    signOutRequest: SignOutRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    signOut<TData = SignOutResponse>(
    signOutRequest: SignOutRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;signOut<TData = SignOutResponse>(
    signOutRequest: SignOutRequest, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.put<TData>(
      `${environment.baseUrl}/admin/auth/sign-out`,
      signOutRequest,options
    );
  }

/**
 * Operation ID: resetAdminPassword


 */
 resetAdminPassword<TData = AdminResetPasswordResponse>(
    adminResetPasswordRequest: AdminResetPasswordRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    resetAdminPassword<TData = AdminResetPasswordResponse>(
    adminResetPasswordRequest: AdminResetPasswordRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    resetAdminPassword<TData = AdminResetPasswordResponse>(
    adminResetPasswordRequest: AdminResetPasswordRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;resetAdminPassword<TData = AdminResetPasswordResponse>(
    adminResetPasswordRequest: AdminResetPasswordRequest, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.put<TData>(
      `${environment.baseUrl}/admin/auth/reset-password`,
      adminResetPasswordRequest,options
    );
  }

/**
 * Operation ID: login


 */
 login<TData = AdminLoginResponse>(
    loginRequest: LoginRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    login<TData = AdminLoginResponse>(
    loginRequest: LoginRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    login<TData = AdminLoginResponse>(
    loginRequest: LoginRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;login<TData = AdminLoginResponse>(
    loginRequest: LoginRequest, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.post<TData>(
      `${environment.baseUrl}/admin/auth/login`,
      loginRequest,options
    );
  }

/**
 * Operation ID: resetAdminPasswordRequest


 */
 resetAdminPasswordRequest<TData = AdminForgotPasswordResponse>(
    adminForgotPasswordRequest: AdminForgotPasswordRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    resetAdminPasswordRequest<TData = AdminForgotPasswordResponse>(
    adminForgotPasswordRequest: AdminForgotPasswordRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    resetAdminPasswordRequest<TData = AdminForgotPasswordResponse>(
    adminForgotPasswordRequest: AdminForgotPasswordRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;resetAdminPasswordRequest<TData = AdminForgotPasswordResponse>(
    adminForgotPasswordRequest: AdminForgotPasswordRequest, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.put<TData>(
      `${environment.baseUrl}/admin/auth/forgot-password`,
      adminForgotPasswordRequest,options
    );
  }

/**
 * Operation ID: uploadTempFile


 */
 uploadTempFile<TData = UploadTempFileResponse>(
    uploadTempFileRequest: UploadTempFileRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    uploadTempFile<TData = UploadTempFileResponse>(
    uploadTempFileRequest: UploadTempFileRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    uploadTempFile<TData = UploadTempFileResponse>(
    uploadTempFileRequest: UploadTempFileRequest, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;uploadTempFile<TData = UploadTempFileResponse>(
    uploadTempFileRequest: UploadTempFileRequest, options?: HttpClientOptions
  ): Observable<TData>  {const formData = new FormData();
formData.append('file', uploadTempFileRequest.file)

    return this.http.put<TData>(
      `${environment.baseUrl}/common/upload/temp`,
      formData,options
    );
  }

/**
 * Operation ID: getStateList


 */
 getStateList<TData = GetStateListResponse>(
    params?: GetStateListParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    getStateList<TData = GetStateListResponse>(
    params?: GetStateListParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    getStateList<TData = GetStateListResponse>(
    params?: GetStateListParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;getStateList<TData = GetStateListResponse>(
    params?: GetStateListParams, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.get<TData>(
      `${environment.baseUrl}/common/states`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Operation ID: getCountryList


 */
 getCountryList<TData = GetCountryListResponse>(
    params?: GetCountryListParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    getCountryList<TData = GetCountryListResponse>(
    params?: GetCountryListParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    getCountryList<TData = GetCountryListResponse>(
    params?: GetCountryListParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;getCountryList<TData = GetCountryListResponse>(
    params?: GetCountryListParams, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.get<TData>(
      `${environment.baseUrl}/common/countries`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Operation ID: getCompanyTypeList


 */
 getCompanyTypeList<TData = GetCompanyTypeListResponse>(
     options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    getCompanyTypeList<TData = GetCompanyTypeListResponse>(
     options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    getCompanyTypeList<TData = GetCompanyTypeListResponse>(
     options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;getCompanyTypeList<TData = GetCompanyTypeListResponse>(
     options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.get<TData>(
      `${environment.baseUrl}/common/company/types`,options
    );
  }

/**
 * Operation ID: getCompanyStatusList


 */
 getCompanyStatusList<TData = GetCompanyStatusListResponse>(
     options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    getCompanyStatusList<TData = GetCompanyStatusListResponse>(
     options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    getCompanyStatusList<TData = GetCompanyStatusListResponse>(
     options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;getCompanyStatusList<TData = GetCompanyStatusListResponse>(
     options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.get<TData>(
      `${environment.baseUrl}/common/company/status`,options
    );
  }

/**
 * Operation ID: getCompanyApplicationStatusList


 */
 getCompanyApplicationStatusList<TData = GetCompanyApplicationStatusListResponse>(
     options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    getCompanyApplicationStatusList<TData = GetCompanyApplicationStatusListResponse>(
     options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    getCompanyApplicationStatusList<TData = GetCompanyApplicationStatusListResponse>(
     options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;getCompanyApplicationStatusList<TData = GetCompanyApplicationStatusListResponse>(
     options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.get<TData>(
      `${environment.baseUrl}/common/company-application-status`,options
    );
  }

/**
 * Operation ID: getBusinessTypeList


 */
 getBusinessTypeList<TData = GetBusinessTypeListResponse>(
    params?: GetBusinessTypeListParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    getBusinessTypeList<TData = GetBusinessTypeListResponse>(
    params?: GetBusinessTypeListParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    getBusinessTypeList<TData = GetBusinessTypeListResponse>(
    params?: GetBusinessTypeListParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;getBusinessTypeList<TData = GetBusinessTypeListResponse>(
    params?: GetBusinessTypeListParams, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.get<TData>(
      `${environment.baseUrl}/common/business-types`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Operation ID: getBusinessSubTypeList


 */
 getBusinessSubTypeList<TData = BusinessSubTypeListResponse>(
    params?: GetBusinessSubTypeListParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
    getBusinessSubTypeList<TData = BusinessSubTypeListResponse>(
    params?: GetBusinessSubTypeListParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
    getBusinessSubTypeList<TData = BusinessSubTypeListResponse>(
    params?: GetBusinessSubTypeListParams, options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;getBusinessSubTypeList<TData = BusinessSubTypeListResponse>(
    params?: GetBusinessSubTypeListParams, options?: HttpClientOptions
  ): Observable<TData>  {
    return this.http.get<TData>(
      `${environment.baseUrl}/common/business-sub-types`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

};

export type GetUserInfoClientResult = NonNullable<GetUserResponse>
export type GetRoleListClientResult = NonNullable<GetRoleListResponse>
export type GetAdminUserListClientResult = NonNullable<GetAdminUserListResponse>
export type CreateAdminUserClientResult = NonNullable<AdminCreateUserResponse>
export type EnableAdminUserClientResult = NonNullable<EnableAdminUserResponse>
export type DisableAdminUserClientResult = NonNullable<DisableAdminUserResponse>
export type UpdateAdminUserClientResult = NonNullable<AdminUpdateUserResponse>
export type AdminCreatePasswordClientResult = NonNullable<AdminSetupPasswordResponse>
export type GetTenantListClientResult = NonNullable<GetTenantListResponse[]>
export type UpdateRequestForDemoStatusClientResult = NonNullable<UpdateRequestForDemoStatusResponse>
export type UpdateRequestForDemoClientResult = NonNullable<UpdateRequestForDemoResponse>
export type GetRequestForDemoClientResult = NonNullable<GetRequestForDemoResponse>
export type GetRequestForDemoStatusListClientResult = NonNullable<GetRequestForDemoStatusListResponse>
export type GetRequestForDemoListClientResult = NonNullable<GetRequestForDemoListResponse>
export type PutPreSignedClientResult = NonNullable<GetUploadPreSignedResponse>
export type GetFileControllerUploadFileClientResult = NonNullable<unknown>
export type FileUploadControllerUploadFileClientResult = NonNullable<FileUploadControllerUploadFile201>
export type UpdateContactUsStatusClientResult = NonNullable<UpdateContactUsStatus>
export type UpdateContactUsClientResult = NonNullable<UpdateContactUsResponse>
export type GetContactUsClientResult = NonNullable<GetContactUs>
export type GetContactUsStatusListClientResult = NonNullable<GetContactUsStatusListResponse>
export type GetContactUsListClientResult = NonNullable<GetContactUsListResponse>
export type RejectCompanyApplicationStatusClientResult = NonNullable<RejectCompanyApplicationStatusResponse>
export type GetCompanyApplicationListClientResult = NonNullable<GetCompanyApplicationListResponse[]>
export type GetCompanyApplicationClientResult = NonNullable<GetCompanyApplicationResponse>
export type DeleteCompanyApplicationControllerExecuteClientResult = NonNullable<void>
export type CompleteCompanyApplicationStatusClientResult = NonNullable<CompleteCompanyApplicationStatusResponse>
export type UpdateGeneralInfoClientResult = NonNullable<UpdateGeneralInfoResponse>
export type UpdateCompanyBasicClientResult = NonNullable<UpdateCompanyBasicResponse>
export type UpdateCompanyAddressClientResult = NonNullable<UpdateCompanyAddressResponse>
export type UpdateCompanyClientResult = NonNullable<UpdateCompanyResponse>
export type UpdateBusinessInfoClientResult = NonNullable<UpdateBusinessInfoResponse>
export type UpdateBusinessAddressClientResult = NonNullable<UpdateBusinessAddressResponse>
export type LinkCompanyToTenantClientResult = NonNullable<LinkCompanyToTenantResponse>
export type InActiveCompanyStatusClientResult = NonNullable<InactiveCompanyStatusResponse>
export type GetCompanyListClientResult = NonNullable<GetCompanyListResponse[]>
export type CreateCompanyClientResult = NonNullable<CreateCompanyResponse>
export type GetCompanyDetailClientResult = NonNullable<GetCompanyDetailResponse>
export type GetCompanyDelegationTokenClientResult = NonNullable<GetCompanyDelegationTokenResponse>
export type GetCompaniesExcludingTenantClientResult = NonNullable<GetCompaniesExcludingTenantResponse[]>
export type ActiveCompanyStatusClientResult = NonNullable<ActiveCompanyStatusResponse>
export type SignOutClientResult = NonNullable<SignOutResponse>
export type ResetAdminPasswordClientResult = NonNullable<AdminResetPasswordResponse>
export type LoginClientResult = NonNullable<AdminLoginResponse>
export type ResetAdminPasswordRequestClientResult = NonNullable<AdminForgotPasswordResponse>
export type UploadTempFileClientResult = NonNullable<UploadTempFileResponse>
export type GetStateListClientResult = NonNullable<GetStateListResponse>
export type GetCountryListClientResult = NonNullable<GetCountryListResponse>
export type GetCompanyTypeListClientResult = NonNullable<GetCompanyTypeListResponse>
export type GetCompanyStatusListClientResult = NonNullable<GetCompanyStatusListResponse>
export type GetCompanyApplicationStatusListClientResult = NonNullable<GetCompanyApplicationStatusListResponse>
export type GetBusinessTypeListClientResult = NonNullable<GetBusinessTypeListResponse>
export type GetBusinessSubTypeListClientResult = NonNullable<BusinessSubTypeListResponse>
